import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;
import { TextProps } from 'antd/lib/typography/Text';

export interface SecondaryTextProps extends TextProps {}

/**
 * Testo centrato per informazioni non rilevamti
 */
export function SecondaryText(props: SecondaryTextProps) {
  return (
    <Text
      type="secondary"
      style={{
        textAlign: 'center',
        display: 'block',
        lineHeight: '1.4em'
      }}
      {...props}
    >
      {props.children}
    </Text>
  );
}
